import i18n from "@/locale/index.js";

const STORAGE_PREFIX = "led_";

const NAME = {
  LANGUAGE: "lang", // LANGUAGE 中心和远端站点复用，不区分 一律用pro_前缀
  // LANGUAGE: STORAGE_PREFIX + "i18next", // LANGUAGE 中心和远端站点复用，不区分 一律用pro_前缀

  USER: STORAGE_PREFIX + "user",
  VERSION: STORAGE_PREFIX + "version", //add in 2.2,新增平台version信息缓存
  LICENSE: STORAGE_PREFIX + "license",
  AES_KEY: STORAGE_PREFIX + "AESKey",
  LICENSE_CHECK: STORAGE_PREFIX + "licenseCheck",
  BLOCK_RES_LIMIT: STORAGE_PREFIX + "blockResLimit", //阻止reload页面后的资源超限错误提示
  // AGENT_AES_KEY: AGENT_STORAGE_PREFIX + "AESKey",
  // AGENT_SID: AGENT_STORAGE_PREFIX + "sid",
  TOKEN_KEY_NUM: STORAGE_PREFIX + "tokenKeyNum",
  // AGENT_TOKEN_KEY_NUM: AGENT_STORAGE_PREFIX + "tokenKeyNum",
  NETWORK_LINK: STORAGE_PREFIX + "NetworkLink",
  MSMTOKEN: "msmToken",
  MAP_STATUS: STORAGE_PREFIX + "mapStatus", // 地图状态，开启还是关闭
  RELOGIN: STORAGE_PREFIX + "relogin",
  // LANGUAGE: STORAGE_PREFIX + "i18next", // LANGUAGE 中心和远端站点复用，不区分
  STATION_LANGUAGE: STORAGE_PREFIX + "station_i18next", // STATION_LANGUAGE 主站语言
  LANGUAGE_LIST: STORAGE_PREFIX + "i18next_list", // LANGUAGE 中心和远端站点复用，不区分
  NO_HINT_PERSON_PRIVATE: STORAGE_PREFIX + "nohintPersonPrivate", //信发新增人员隐私提示
  PERSON_PHOTO: STORAGE_PREFIX + "photoParam",
  PERSON_CARD: STORAGE_PREFIX + "cardParam",
  PERSON_FINGER: STORAGE_PREFIX + "fingerParam",
  MULTI_DEVICE: STORAGE_PREFIX + "multiFunCollectParam",
  FIRST_USE_SYSTEM: STORAGE_PREFIX + "firstUseSystem",
  OVERVIEW_SELECT_CAMERA: STORAGE_PREFIX + "cameraType",
  OVERVIEW_SELECT_DEVICE_TYPE: STORAGE_PREFIX + "deviceType",
  OVERVIEW_SELECT_CAMERARECORD: STORAGE_PREFIX + "recordType",
  ALARM_INTERCEPT: STORAGE_PREFIX + "alarm_interceptors", //屏蔽报警的列表
  APP_NAME: STORAGE_PREFIX + "app_name",
  PERMESSION: STORAGE_PREFIX + "permission",
  PRODUCTINFO: STORAGE_PREFIX + "product", //多版本产品信息
  PRODUCT_CONFIG: STORAGE_PREFIX + "product_config", //产品配置信息
  QUERY: STORAGE_PREFIX + "query",
  CONTROL_ITEM: STORAGE_PREFIX + "ControlItem", // 全局控制项
  PORTAL_URL: STORAGE_PREFIX + "PortalUrl", // 登录URL
  THIRD_APP_URL: STORAGE_PREFIX + "thirdAppUrl", // 三方应用首页地址
  GUID_STATUS: STORAGE_PREFIX + "guide_status", // 登录URL
  APP: STORAGE_PREFIX + "app_config", // app配置信息
  CURRENCY_SYMBOL: "currency_symbol",
  SECOND_AUTH: STORAGE_PREFIX + "second_auth",
  SESSION_TIP: STORAGE_PREFIX + "show_session_expire_tip",
  NAV_LIST_STATUS: "nav_list_status",
  SELECT_COUNTRY: "select_country",
  SELECT_COUNTRY_TEST: "select_country_test",
  SELECT_COUNTRY_LOCAL: "select_country_local",
  MENU_POPOVER_ONCE: STORAGE_PREFIX + "menu_popover_once", //刷新提示信息是否显示
  MENU_POPOVER_NEVER: STORAGE_PREFIX + "menu_popover_never", //刷新提示信息是否永远不显
  GUID_MODULE_STATUS: STORAGE_PREFIX + "guide_module_status", // 引导各模块操作状态
};

export default {
  set (key, data) {
    if (typeof data === "object") {
      //如果是对象类型，则进行转成json字符串
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      //如果是基本数据类型(不考虑symbol)则直接设置,用setItem方法内部toString方法逻辑自动转成字符串;
      localStorage.setItem(key, data);
    }
  },
  get (key) {
    let value = "";
    try {
      //统一进行json字符串转义成json对象
      value = JSON.parse(localStorage.getItem(key));
      if (key == NAME.LANGUAGE) {
        return i18n.locale
      } else {
        return value;
      }
    } catch (e) {
      value = localStorage.getItem(key); //如果转义失败，如直接存的是字符串，则直接取了返回
      if (key == NAME.LANGUAGE) {
        return i18n.locale
      } else {
        return value;
      }
    }
  },
  delete (key) {
    localStorage.removeItem(key);
  },
  clear () {
    // 不要清除的字段
    let keepField = [
      NAME.LANGUAGE,
      NAME.LANGUAGE_LIST,
      NAME.PRODUCT_CONFIG,
      NAME.PERSON_PHOTO,
      NAME.PERSON_CARD,
      NAME.PERSON_FINGER,
      NAME.PERSON_ID_CARD,
      NAME.MULTI_DEVICE,
      NAME.PRODUCTINFO,
      NAME.WALL_BATCH,
      NAME.VERSION,
      NAME.ACCESS_COLUMN,
      NAME.ACCESS_EXPORT_COLUMN,
      NAME.SHOWTIP,
      NAME.NO_HINT_PERSON_PRIVATE,
      NAME.MENU_POPOVER_NEVER,
    ];
    for (const key in NAME) {
      if (!keepField.includes(NAME[key])) {
        localStorage.removeItem(NAME[key]);
      }
    }

    sessionStorage.clear();
  },
  getName () {
    return NAME;
  },
  NAME,
};
